import React from 'react';
import {
  RadioButtonGroup,
  RadioButton,
} from 'material-ui';

class GuestsComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  componentWillMount = () => {
    this.props.handleBookingsChange([0, 1, 3, 4, 6, 10, 11]);
  }

  handleBookingsChange = (e, value) => { // eslint-disable-line consistent-return
    if (value === 'booked') {
      return this.props.handleBookingsChange([0, 1, 3, 4, 6, 10, 11]);
    }
    if (value === 'cancelled') {
      return this.props.handleBookingsChange([2]);
    }
    if (value === 'noShow') {
      return this.props.handleBookingsChange([8]);
    }
    if (value === 'denied') {
      return this.props.handleBookingsChange([7]);
    }
    if (value === 'dropIns') {
      return this.props.handleBookingsChange([0, 1, 3, 4, 6, 10, 11], { onlyDrops: true });
    }
  }

  handleSeatingChange = (e, value) => this.props.handleSeatingChange(value);

  render() {
    const { translate } = this.props;
    return (
      <div className="guests">
        <div className="booking-type">
          <h2>{translate('statistics.bookingType')}</h2>
          <RadioButtonGroup
            onChange={this.handleBookingsChange}
            defaultSelected="booked"
            className="booking-group"
          >
            <RadioButton value="booked" label={translate('statistics.booked')} />
            <RadioButton value="cancelled" label={translate('statistics.cancelled')} />
            <RadioButton value="noShow" label={translate('statistics.noShow')} />
            <RadioButton value="denied" label={translate('statistics.denied')} />
            <RadioButton value="dropIns" label={translate('statistics.dropIns')} />
          </RadioButtonGroup>
        </div>

        <div className="date-type">
          <h2>{translate('statistics.dateType')}</h2>
          <RadioButtonGroup
            onChange={this.handleSeatingChange}
            defaultSelected="seating"
            className="seating-group"
          >
            <RadioButton value="seating" label={translate('statistics.seatingDate')} />
            <RadioButton value="booking" label={translate('statistics.bookingDate')} />
          </RadioButtonGroup>
        </div>

      </div>
    );
  }
}

export default GuestsComponent;
